const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIqLogoDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 638.31,
    height: 102.59,
    viewBox: "0 0 638.31 102.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "182.22 0 182.22 80.22 239.78 80.22 239.78 66.44 197.56 66.44 197.56 47.33 233.33 47.33 233.33 32.89 197.78 32.89 197.78 14.22 238.67 14.22 238.67 0 182.22 0",
    style: {
      fill: "#effff6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.89 0 252.89 80.22 268.89 80.22 268.89 27.33 310 80.22 323.78 80.22 323.78 0 308.44 0 308.44 51.56 268.44 0 252.89 0",
    style: {
      fill: "#effff6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.33 0 335.33 14.22 361.33 14.22 361.33 80.22 377.11 80.22 377.11 14.67 402.67 14.67 402.67 0 335.33 0",
    style: {
      fill: "#effff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.36,1.44c-21.45,0-38.83,17.64-38.83,39.39s17.39,39.39,38.83,39.39,38.83-17.64,38.83-39.39S465.8,1.44,444.36,1.44ZM444.36,66.58c-14.02,0-25.38-11.53-25.38-25.74s11.36-25.74,25.38-25.74,25.38,11.53,25.38,25.74-11.36,25.74-25.38,25.74Z",
    style: {
      fill: "#effff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.44,50.22s14.67-6.44,14.22-25.11c-.44-18.67-20.22-25.11-20.22-25.11h-44.89v80.22h15.78v-27.56h19.33l16.22,27.56h19.11l-19.56-30ZM537.56,38.22h-27.33V13.78h26.22s9.11,2.22,9.11,12.22-8,12.22-8,12.22Z",
    style: {
      fill: "#effff6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.78 0 593.11 48.44 593.11 80.22 609.78 80.22 609.78 48.89 638.22 0 620.44 0 602 32.44 582.44 0 563.78 0",
    style: {
      fill: "#effff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.83,52s-4.67-5.5-3.83-23.33c.04-.96.07-1.88.08-2.78-4.24-3.96-9.87-6.38-16.04-6.38-13.21,0-23.92,11.06-23.92,24.71s10.71,24.71,23.92,24.71c2.65,0,5.19-.45,7.58-1.27-.04-.07-2.5-3.91,1.38-6.22,3.56-2.11,5.81,2.21,5.81,2.21,3.67-2.98,6.47-7.06,7.96-11.74-1.8.12-2.93.09-2.93.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.08,25.89c0,.89-.03,1.82-.08,2.78-.83,17.83,3.83,23.33,3.83,23.33,0,0,1.13.03,2.93-.09.77-2.42,1.19-5,1.19-7.69,0-7.27-3.04-13.81-7.88-18.33Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.02,74.04c8.46-6.69,14.19-16.86,15.2-28.45-5.4,3.08-11.89,3.97-15.61,4.22-1.53,4.82-4.41,9.01-8.19,12.08,0,0-2.32-4.44-5.97-2.27-3.99,2.37-1.47,6.32-1.42,6.39-2.45.84-5.07,1.31-7.79,1.31-13.59,0-24.6-11.38-24.6-25.42s11.02-25.42,24.6-25.42c6.35,0,12.13,2.48,16.5,6.56.1-10.51-2.15-16.5-3.73-19.39-4-1.43-8.3-2.21-12.77-2.21-21.63,0-39.16,18.11-39.16,40.46s17.53,40.46,39.16,40.46c3.4,0,6.7-.45,9.84-1.29l14.76,21.52h19.36l-20.18-28.55Z",
    style: {
      fill: "#effff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.73,23.05c4.98,4.65,8.11,11.38,8.11,18.86,0,2.76-.44,5.42-1.23,7.91,3.72-.25,10.2-1.14,15.61-4.22.11-1.22.18-2.44.18-3.69,0-17.72-11.04-32.78-26.39-38.25,1.58,2.89,3.82,8.88,3.73,19.39Z",
    style: {
      fill: "#00c1d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33,30.98V2.33H0v41.64c2.93-.71,10.08-3.39,15.33-12.99Z",
    style: {
      fill: "#effff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,54.34v28.22h15.33v-30.54c-2.65.26-9.38,1-15.33,2.32Z",
    style: {
      fill: "#00c1d5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.89,
    y: 90.6,
    width: 385.42,
    height: 6.44,
    rx: 3.22,
    ry: 3.22,
    style: {
      fill: "#00c1d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.14,20.15c-4.8-4.48-11.16-7.22-18.14-7.22-14.95,0-27.06,12.52-27.06,27.96s12.12,27.96,27.06,27.96c3,0,5.88-.51,8.57-1.44-.05-.08-2.83-4.42,1.57-7.03,4.02-2.39,6.57,2.5,6.57,2.5,4.15-3.38,7.32-7.98,9-13.29.87-2.74,1.35-5.66,1.35-8.7,0-8.23-3.44-15.63-8.92-20.74Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,90.6H100.71s-.04.03-.03.05l4.51,6.38s.02.01.03.01h131.34c1.83,0,3.3-1.52,3.22-3.37s-1.67-3.08-3.43-3.08Z",
    style: {
      fill: "#9bdc50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22,90.6c-1.83,0-3.3,1.52-3.22,3.37s1.67,3.08,3.43,3.08h74.79s.04-.03.03-.05l-4.38-6.38s-.02-.01-.03-.01H3.22Z",
    style: {
      fill: "#9bdc50"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.11 0 130.22 80.22 144 80.22 175.33 0 157.78 0 137.33 54.89 115.78 0 97.11 0",
    style: {
      fill: "#effff6"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqLogoDark);
export default __webpack_public_path__ + "static/media/IQ_logo_dark.c882b3f12c3df4451da82b6b02bfcfc2.svg";
export { ForwardRef as ReactComponent };